import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CheckCircle2, Clock } from "lucide-react";
import { OpeningWizard } from "@/components/opening/OpeningWizard";
import { OpeningReports } from "@/components/opening/OpeningReports";
import { OpeningEditor } from "@/components/opening/OpeningEditor";
import { useOpeningToday } from "@/components/opening/OpeningPrompt";

function TodayTab() {
  const [t, reload] = useOpeningToday();
  if (!t) return null;
  if (!t.applicable) return <div className="text-sm text-slate-500 py-8" data-testid="opening-not-applicable">Açılış listesi şube personeli içindir. Raporlar sekmesinden şubeleri izleyebilirsiniz.</div>;
  if (t.done) {
    const c = t.checklist;
    return (
      <div className="rounded-3xl border border-emerald-500/30 bg-emerald-500/5 p-6 flex items-center gap-4" data-testid="opening-today-done">
        <CheckCircle2 size={36} className="text-emerald-400 shrink-0" />
        <div><div className="font-display text-xl font-bold">Bugünün açılış listesi tamam</div>
          <div className="text-sm text-slate-400"><b className="text-slate-200">{c.done_by_name}</b> doldurdu · {new Date(c.done_at).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Istanbul" })}{c.no_count ? ` · ${c.no_count} sorun bildirildi` : ""}</div></div>
      </div>
    );
  }
  if (!t.assigned) return <div className="rounded-3xl border border-slate-800 bg-slate-900/60 p-6 flex items-center gap-3 text-slate-400" data-testid="opening-not-assigned"><Clock size={22} /> Açılış listesi her sabah 08:20'de atanır.</div>;
  return <OpeningWizard questions={t.questions} branchName={t.branch_name} onDone={reload} />;
}

export default function Opening() {
  const { user } = useAuth();
  const branchUser = ["mudur", "personel"].includes(user?.role) && user?.branch_id;
  return (
    <div className="space-y-6 max-w-3xl" data-testid="opening-page">
      <header className="animate-fade-up">
        <h1 className="font-display text-3xl font-bold">Mağaza Açılış Listesi</h1>
        <p className="text-slate-400 text-sm mt-1">Her sabah 08:20'de atanır; şubeden bir kişinin doldurması yeterli.</p>
      </header>
      <Tabs defaultValue={branchUser ? "today" : "reports"}>
        <TabsList className="bg-slate-900 border border-slate-800">
          <TabsTrigger value="today" data-testid="opening-tab-today">Bugün</TabsTrigger>
          <TabsTrigger value="reports" data-testid="opening-tab-reports">Raporlar</TabsTrigger>
          {user?.role === "koordinator" && <TabsTrigger value="editor" data-testid="opening-tab-editor">Liste Ayarları</TabsTrigger>}
        </TabsList>
        <TabsContent value="today" className="mt-4"><TodayTab /></TabsContent>
        <TabsContent value="reports" className="mt-4"><OpeningReports /></TabsContent>
        {user?.role === "koordinator" && <TabsContent value="editor" className="mt-4"><OpeningEditor /></TabsContent>}
      </Tabs>
    </div>
  );
}
